export const FOCUS_ELEMENT_ACTIONS = 'FOCUS_ELEMENT_ACTIONS';
export const UNFOCUS_ELEMENT_ACTIONS = 'UNFOCUS_ELEMENT_ACTIONS';

export const focusElement = elem => {
  return {
    type: FOCUS_ELEMENT_ACTIONS,
    elem
  };
};

export const unFocusElement = () => {
  return {
    type: UNFOCUS_ELEMENT_ACTIONS
  };
};